export const DocumentType = Object.freeze({
  PASSPORT: "PASSPORT",
  ID_CARD: "ID_CARD",
  DRIVING_LICENSE: "DRIVING_LICENSE",
});

/**
 * @typedef {Object} VerificationResult
 * @property {boolean} isValid
 * @property {DocumentType | 'UNKNOWN'} detectedType
 * @property {string} detectedCountry
 * @property {number} confidence
 * @property {string} reasoning
 * @property {boolean} isPhysicalDocument
 * @property {Object} [forensics]
 * @property {number} forensics.livenessScore
 * @property {boolean} forensics.humanPresenceDetected
 * @property {number} forensics.perspectiveSkew
 * @property {boolean} forensics.glareDetected
 * @property {Object} [extractedInfo]
 * @property {string} [extractedInfo.name]
 * @property {string} [extractedInfo.expiryDate]
 * @property {string} [extractedInfo.documentNumber]
 * @property {string} [extractedInfo.dob]
 * @property {string} [extractedInfo.address]
 */

/**
 * @typedef {Object} AppState
 * @property {'CONSENT' | 'SELECT' | 'CAPTURE_FRONT' | 'CAPTURE_BACK' | 'VERIFYING' | 'RESULT'} step
 * @property {DocumentType} selectedType
 * @property {string} selectedCountry
 * @property {string | null} capturedFront
 * @property {string | null} capturedBack
 * @property {VerificationResult | null} result
 * @property {boolean} hasConsented
 */
